import graphqlClient from '~/graphql/graphqlClient';
import type { ItemLocationInput, ItemMoveResult } from './mutationPlaceItemInGlobalInventory';

const mutation = `
mutation EquipBagToHeroBagSlot(
  $playerId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  equipBagToHeroBagSlot(
    playerId: $playerId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export type EquipBagToHeroBagSlotArgs = {
  playerId: string;
  from: ItemLocationInput;
  to: ItemLocationInput;
};

export default async function mutationEquipBagToHeroBagSlot(
  args: EquipBagToHeroBagSlotArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>(
    'equipBagToHeroBagSlot',
    mutation,
    args
  );
}
